import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { DataSourceConfig } from '@core/models';
import { UpdateDataSourceConfigAction, AddDataSourceConfigAction } from '@ngxs-store/data-source-configs-store/data-source-configs.actions';
import { UiState } from '@ngxs-store/ui-store/ui.state';
import { Injectable } from '@angular/core';

export class DataSourceConfigsStateModel {
  public dataSourceConfigs: DataSourceConfig[];
}

@State<DataSourceConfigsStateModel>({
  name: 'dataSourceConfigs',
  defaults: {
    dataSourceConfigs: []
  }
})
@Injectable()
export class DataSourceConfigsState {
  constructor(private store: Store) { }

  @Selector()
  static getDataSourceConfigs(state: DataSourceConfigsStateModel) {
    return state.dataSourceConfigs;
  }

  @Selector()
  static getDataSourceConfig(state: DataSourceConfigsStateModel) {
    return (name: string) => {
      return state.dataSourceConfigs.find((dsc) => dsc.name === name);
    };
  }

  @Action(AddDataSourceConfigAction)
  addDataSourceConfigAction(ctx: StateContext<DataSourceConfigsStateModel>, action: AddDataSourceConfigAction) {
    const state = ctx.getState();
    const isMobileMode = this.store.selectSnapshot(UiState.getIsMobileMode);

    isMobileMode ? action.payload.dataSourceConfig = { ...action.payload.dataSourceConfig, columns: action.payload.dataSourceConfig.mobileModeColumns } :
      action.payload.dataSourceConfig = { ...action.payload.dataSourceConfig, columns: action.payload.dataSourceConfig.desktopModeColumns };

    if (state.dataSourceConfigs.findIndex((dsc) => dsc.name === action.payload.dataSourceConfig.name) === -1) {
      ctx.patchState({
        dataSourceConfigs: [...state.dataSourceConfigs, action.payload.dataSourceConfig]
      });
    }
  }

  @Action(UpdateDataSourceConfigAction)
  updateDataSourceConfigAction(ctx: StateContext<DataSourceConfigsStateModel>, action: UpdateDataSourceConfigAction) {
    const state = ctx.getState();

    ctx.patchState({
      dataSourceConfigs: [
        ...state.dataSourceConfigs.map((dsc) => (dsc.name === action.payload.dataSourceConfig.name ? action.payload.dataSourceConfig : dsc))
      ]
    });
  }
}
